(function () {
  'use strict';
  var selector = '.player-addplaylist,.player-playtrack-button,.product-details__player-addplaylist';
  var pending = null;
  var record = '<svg class="cchw-play-record" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle class="cchw-play-record__centre" cx="12" cy="12" r="2.5"/><path d="M12 5a7 7 0 0 1 7 7M5 12a7 7 0 0 0 7 7"/></svg>';

  function finish() {
    if (!pending) return;
    var previous=pending;pending=null;
    previous.observer.disconnect();clearTimeout(previous.timer);
    previous.button.classList.remove('cchw-play-buffering','cchw-player-triggered','is-loading-track');
    if (previous.busy === null) previous.button.removeAttribute('aria-busy');
    else previous.button.setAttribute('aria-busy',previous.busy);
  }

  function titleFor(button) {
    if (button.classList.contains('player-playtrack-button')) return button.dataset.src ? button.dataset.track || '' : null;
    var archive = button.classList.contains('product-details__player-addplaylist') ? button.closest('.archive-playlist') : button.parentElement.querySelector('.archive-playlist');
    var first = archive && archive.querySelector('span[data-src]');
    return first ? first.dataset.track || '' : null;
  }

  function start(button, title) {
    var player=document.querySelector('.cchw-player-wrapper');
    var icon=button.querySelector('svg,.cchw-cart-line-player__icon,.cchw-cart-player-review__play-icon');
    if (!player || !icon) return;
    if (!button.querySelector('.cchw-play-record')) {
      var width=icon.getBoundingClientRect().width || 18;
      var height=icon.getBoundingClientRect().height || 18;
      icon.classList.add('cchw-play-original');
      icon.insertAdjacentHTML('afterend',record);
      var disc=button.querySelector('.cchw-play-record');
      disc.style.width=Math.max(14,width)+'px';disc.style.height=Math.max(14,height)+'px';
    }
    var current={button:button,busy:button.getAttribute('aria-busy')};pending=current;
    button.classList.add('cchw-play-buffering');button.setAttribute('aria-busy','true');
    function check() {
      if (pending !== current) return;
      var now=player.querySelector('#cchw-player-currently-playing-title');
      if (!button.isConnected || (player.querySelector('button[aria-label="Pause"]:not([disabled])') && now && now.textContent.trim() === title.trim())) finish();
    }
    current.observer=new MutationObserver(check);
    current.observer.observe(player,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','disabled']});
    current.timer=setTimeout(function () { if (pending === current) finish(); },15000);
    setTimeout(check,0);
  }

  window.addEventListener('click',function (event) {
    var button=event.target.closest(selector);
    if (!button) {
      if (event.target.closest('.cchw-player-wrapper button')) finish();
      return;
    }
    finish();
    if (button.disabled || button.hasAttribute('data-crate-listen')) return;
    var title=titleFor(button);
    if (title !== null) start(button,title);
  },true);
  window.addEventListener('pagehide',finish);

  var player=document.querySelector('.cchw-player-wrapper');
  if (!player) return;
  var audio=null;
  var track=null;
  var failedTrack=null;
  var manualPause=false;
  var suspended=false;
  var buffering=false;
  var busyButton=null;
  var previousBusy=null;
  var timer=null;
  var lastTime=0;
  var lastProgress=Date.now();
  var waitingSince=null;
  var mediaEvents=['waiting','stalled','seeking','playing','seeked','pause','ended','error','emptied','timeupdate'];
  var playSelector='button[aria-label="Play"],button[aria-label="Pause"],button[aria-label="Play Requested"]';

  function selectedTrack() {
    return window.Player && window.Player.currentlyLoadedTrack;
  }
  function selectedAudio() {
    var selected=selectedTrack();
    var sounds=selected && selected.howl && selected.howl._sounds;
    return sounds && sounds[0] && sounds[0]._node;
  }
  function requested() {
    var button=player.querySelector(playSelector);
    var label=button && button.getAttribute('aria-label');
    if (label !== 'Pause') manualPause=false;
    return !suspended && !manualPause && track !== failedTrack && audio && !audio.ended && (label === 'Pause' || label === 'Play Requested');
  }
  function restoreBusy() {
    if (!busyButton) return;
    if (previousBusy === null) busyButton.removeAttribute('aria-busy');
    else busyButton.setAttribute('aria-busy',previousBusy);
    busyButton=null;
  }
  function paintBuffering() {
    player.classList.toggle('cchw-audio-buffering',buffering);
    var button=player.querySelector(playSelector);
    if (busyButton && (busyButton !== button || !buffering)) restoreBusy();
    if (buffering && button && busyButton !== button) {
      busyButton=button;
      previousBusy=button.getAttribute('aria-busy');
      button.setAttribute('aria-busy','true');
    }
  }
  function detachAudio() {
    if (audio) mediaEvents.forEach(function (name) { audio.removeEventListener(name,onMediaEvent); });
    audio=null;
  }
  function sample() {
    var now=Date.now();
    if (!requested()) {
      buffering=false;
      waitingSince=null;
      lastProgress=now;
      if (timer !== null) { clearTimeout(timer);timer=null; }
    } else {
      var position=audio.currentTime;
      if (Number.isFinite(position) && position !== lastTime) {
        lastTime=position;
        lastProgress=now;
        waitingSince=null;
      }
      if (audio.readyState < 3 && waitingSince === null) waitingSince=now;
      buffering=(waitingSince !== null && now-waitingSince >= 500 && now-lastProgress >= 500) || now-lastProgress >= 1500;
      if (timer === null) timer=setTimeout(function () { timer=null;syncAudio(); },250);
    }
    paintBuffering();
  }
  function syncAudio() {
    if (suspended) return;
    var next=selectedAudio();
    var nextTrack=selectedTrack();
    if (next !== audio || nextTrack !== track) {
      var continuingWait=buffering && next && nextTrack === track;
      detachAudio();
      track=nextTrack;
      if (!continuingWait) {
        lastProgress=Date.now();
        waitingSince=null;
      }
      if (next && typeof next.addEventListener === 'function') {
        audio=next;
        lastTime=Number.isFinite(audio.currentTime) ? audio.currentTime : 0;
        mediaEvents.forEach(function (name) { audio.addEventListener(name,onMediaEvent); });
      }
    }
    sample();
  }
  function onMediaEvent(event) {
    if (event.currentTarget !== audio || audio !== selectedAudio()) return;
    if (event.type === 'waiting' || event.type === 'emptied') {
      if (waitingSince === null) waitingSince=Date.now();
    }
    if (event.type === 'seeking') {
      lastTime=audio.currentTime;
      lastProgress=Date.now();
      waitingSince=null;
    }
    if (event.type === 'playing' && audio.readyState >= 3) {
      lastProgress=Date.now();
      waitingSince=null;
    }
    if (event.type === 'error' && audio.error && (audio.error.code === 3 || audio.error.code === 4)) failedTrack=track;
    sample();
  }
  var audioObserver=new MutationObserver(syncAudio);
  function observeAudio() {
    suspended=false;
    audioObserver.observe(player,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-label']});
    syncAudio();
  }
  window.addEventListener('click',function (event) {
    var button=event.target.closest('.cchw-player-wrapper button');
    if (button && button.getAttribute('aria-label') === 'Pause') {
      manualPause=true;
      sample();
    } else if ((button && !button.disabled) || event.target.closest(selector)) {
      manualPause=false;
      failedTrack=null;
      setTimeout(syncAudio,0);
    }
  },true);
  window.addEventListener('cchw:seek-diagnostic',function (event) {
    if (event.detail && event.detail.type === 'failed') { failedTrack=selectedTrack();sample(); }
  });
  observeAudio();
  window.addEventListener('pagehide',function () {
    suspended=true;
    audioObserver.disconnect();
    if (timer !== null) { clearTimeout(timer);timer=null; }
    detachAudio();
    buffering=false;
    paintBuffering();
  });
  window.addEventListener('pageshow',observeAudio);
})();
